import { createAuthClient } from 'better-auth/client';
import { ssoClient } from '@better-auth/sso/client'

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_BETTER_AUTH_URL,
  plugins: [
    ssoClient()
  ]
});
